<template>

<div class="widget-item">
    <div class="widget-item-body">

        <div class="widget-item-text">

            <p class="widget-item-description" v-if="widget.description">{{widget.description}}</p>



        </div>

        <div class="widget-item-chart">
        
            <canvas :id="`chart_${widget.id}`" />

        </div>

    </div>

</div>
</template>

<script>

import { parseData, initChart } from '@/components/charts/DynamicChart.js'

export default {
    name: 'RiskStratificationWidget',
    props: {
        widget: Object
    },
    data(){
        return {
            chart: null,
            chartData: [],
            labels: []
        }
    },
    computed: {
        variables(){
            return this.widget.variables
        },
        outputData(){
            return this.$store.getters['getOutputs'](this.variables)
        },
        output(){
            return parseData(this.outputData, this.widget.parameters.target_states)[0]
        },
        cumulativeStrata(){
            let tot = 0
            return this.widget.parameters.strata.map((el) => {
                tot = tot + el
                return tot
            })
        },
        strataIndex(){
            return this.cumulativeStrata.findIndex((value) => value > this.output)
        },
        riskValues(){
            return this.widget.parameters.riskValues
        },
        riskLevel(){
            return this.widget.parameters.strataNames[this.strataIndex]
        }
    },
    watch: {
        outputData(data){
            
            const d = new Date()

            this.labels.push(d.toTimeString().slice(0, 8))
            this.chartData.push(parseData(data, this.widget.parameters.target_states)[0])

            this.chart.data.datasets[0].data = this.chartData
            this.chart.data.labels = this.labels

            this.chart.update()
        }
    },
    mounted(){

        const d = new Date()

        this.labels.push(d.toTimeString().slice(0, 8))
        this.chartData.push(this.output)

        //console.log(this.chartData)

        const ctx = document.getElementById(`chart_${this.widget.id}`)
        this.chart = initChart(ctx, this.labels, this.chartData, this.widget.parameters)
    }
}


</script>